import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { VcaCommonModule } from '../../../../common';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { ClarityModule } from '@clr/angular';
import { NetworkingDashboard } from './dashboard/networking-vcd-dashboard.component';
import NetworkingVcdView from './networking-vcd.components';
import { ActivityLogModule } from "../../../components/activity-log/activity-log.module";

@NgModule({
    declarations: [
        NetworkingDashboard,
        NetworkingVcdView
    ],
    exports: [
        NetworkingDashboard,
        NetworkingVcdView
    ],
    imports: [
        TranslateModule,
        VcaCommonModule,
        ActivityLogModule,
        ClarityModule,
        BrowserModule
    ]
})

export class NetworkingVcdModule {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vcd/networking-vcd.module.ts